import React from 'react';
import { formatHours } from '../../utils/formatHours';

/**
 * LaborKpiStrip
 * Displays 4 KPI summary cards across the top of the analytics view.
 * Props: packagesShown, overBudget, approaching, hoursValue, hoursLabel, hoursSub
 */
const LaborKpiStrip = ({
  packagesShown,
  overBudget,
  approaching,
  hoursValue,
  hoursLabel,
  hoursSub,
}) => {
  const kpis = [
    {
      label: 'Packages Shown',
      value: String(packagesShown),
      sub: 'in current view',
      color: '#8b5cf6',
    },
    {
      label: 'Over Budget',
      value: String(overBudget),
      sub: 'all-time hours exceeded budget',
      color: overBudget > 0 ? '#ef4444' : '#15803d',
    },
    {
      label: 'Approaching Limit',
      value: String(approaching),
      sub: '85–100% of budget used',
      color: approaching > 0 ? '#f59e0b' : '#15803d',
    },
    {
      label: hoursLabel,
      value: formatHours(hoursValue),
      sub: hoursSub,
      color: '#3b82f6',
    },
  ];

  return (
    <div style={{ display: 'flex', gap: 12 }}>
      {kpis.map((k) => (
        <div
          key={k.label}
          style={{
            flex: 1,
            backgroundColor: '#fff',
            borderRadius: 10,
            padding: '14px 18px',
            borderTop: `3px solid ${k.color}`,
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          }}
        >
          <div style={{ fontSize: 26, fontWeight: 800, color: k.color }}>
            {k.value}
          </div>
          <div
            style={{
              fontSize: 12,
              fontWeight: 600,
              color: '#475569',
              marginTop: 2,
            }}
          >
            {k.label}
          </div>
          {k.sub && (
            <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>
              {k.sub}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default LaborKpiStrip;
